import React from 'react';
import PropTypes from 'prop-types';
import { Button as BButton } from 'reactstrap';
import { useFormikContext } from 'formik';

const FormButton = (props) => {
  let formikContext = useFormikContext();
  return <BButton {...props}
                  disabled={!(formikContext.dirty && formikContext.isValid) || formikContext.isSubmitting} />;
};

const Button = ({ type = 'button', ...props }) => {
  return ['submit', 'reset'].includes(type) ? (
    <FormButton type={type} {...props} />
  ) : (
    <BButton type='button' {...props} />
  );
};
Button.propTypes = {
  type: PropTypes.oneOf(['submit', 'reset', 'button']),
};

export default Button;
